<template>
  <SplashScreen class="admin">
    <SplashScreenContent class="width-auto align-top">
      <VWrapper>
        <TalkingPointsResourceManage
          :patch-data-client="patchDataClient"
          :model="talkingPointsResourceModel"
        />
      </VWrapper>
    </SplashScreenContent>
  </SplashScreen>
</template>

<script setup lang="ts">
  // Types
  import type { ITalkingPointsResourceModel } from '~/misc/talking-points-resource/types';
  import type { TPatchDataClient } from '~/misc/patch/types';

  // Services
  import { PatchDataClient } from '~/misc/patch/services/patch-data-client';

  // Models
  import { TalkingPointsResourceModel } from '~/misc/talking-points-resource/models';

  // Components
  import SplashScreen from '~/misc/splash-screen/SplashScreen.vue';
  import SplashScreenContent from '~/misc/splash-screen/content/SplashScreenContent.vue';
  import VWrapper from '~/misc/v-wrapper/VWrapper.vue';
  import TalkingPointsResourceManage from '~/misc/talking-points-resource/manage/TalkingPointsResourceManage.vue';

  definePageMeta({
    layout: 'admin',
    middleware: ['auth', 'admin', 'pitch-panel-permission'],
  });

  const talkingPointsResourceModel: ITalkingPointsResourceModel = new TalkingPointsResourceModel();
  const patchDataClient: TPatchDataClient = new PatchDataClient();
</script>
